const lang: any = {
    nodata: {
        PT: 'Não há dados cadastrados',
        US: 'No data found',
        ES: 'Sem dados'
    }
}

export default lang